import { render, staticRenderFns } from "./SignupDetail.vue?vue&type=template&id=0d958e22&scoped=true&"
import script from "./SignupDetail.vue?vue&type=script&lang=js&"
export * from "./SignupDetail.vue?vue&type=script&lang=js&"
import style0 from "./SignupDetail.vue?vue&type=style&index=0&id=0d958e22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d958e22",
  null
  
)

export default component.exports